export const CompanyProfileMockData = {
    companyName: "Ingoude Construction",
    name: "Steve Rogers",
    companyDescription:
      "Ingoude Construction provides the best in the flooring services. Focused on customer service and high quality work.",
    image:
      "https://cdn.pixabay.com/photo/2014/06/03/19/38/board-361516_1280.jpg",
    servicesOffered: ["North Vancouver", "Toronto", "Brampton", "Oakville", "South Vancouver"],
    specialities: ["Plumbing", "Electrical", "Roofing", "Painting Services"],
    phone: "2013246723",
    email: "ingoudeinfo@gmail.com",
    websiteUrl: "www.ingoudeconstructions.com"
  };
  